import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { questionValidation } from '../../functions/Validation';
import QuestionHelp from '../question/QuestionHelp';
import ValidationMessage from '../question/ValidationMessage';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';
import { ddMmYyyyToIsoDate, getDateFromIsoDateTime, getDateFromDaysOffset } from '../../functions/DateTime'

export default function DatePicker(props: any) {

    const [question, setQuestion] = useState(props.question);
    const [dateValue, setDateValue] = useState(question.answer);
    const [secondsFocused, setSecondsFocused] = useState(0);
    const timerId = useRef<number>(0);
    const today = getDateFromDaysOffset(0);
    const tomorrow = getDateFromDaysOffset(1);

    var inputClasses = classNames(
        {
            'validation-fail': question.validationFail
        }
    );

    var labelClasses = classNames(
        {
            'validation-fail-lbl': question.validationFail
        }
    );


    let startRange = null;
    if (question.questionSetAnswerType.startRange !== null && question.questionSetAnswerType.startRange !== undefined) {
        startRange = new Date();
        startRange.setDate(question.questionSetAnswerType.startRange);
    }

    let endRange = null;
    if (question.questionSetAnswerType.startRange !== null && question.questionSetAnswerType.startRange !== undefined) {
        endRange = new Date();
        endRange.setDate(question.questionSetAnswerType.endRange);
    }

    useEffect(() => {
        setQuestion(props.question);
        if (props.question.answer) {
            setDateValue(props.question.answer);
        }
    }, [props.question]);

    useEffect(() => {
        if (secondsFocused === 60) {
            //alert("Too much time has passed");
            //alert(question.questionSetQuestion.text);
        }
    }, [secondsFocused]);

    useEffect(() => {
        question.answer = dateValue;
        setQuestion(question);
        props.setIndividualCustomerDetails(question);
        props.enableQuestions(question.questionSetQuestion.questionID);
    }, [dateValue])

    const startTimer = () => {
        timerId.current = window.setInterval(() => {
            setSecondsFocused(prev => prev + 1);
        }, 1000)
    };

    const stopTimer = () => {
        window.clearInterval(timerId.current);
        setSecondsFocused(0);
    };

    const updateAnswer = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDateValue(e.target.value);
    };

    const validateAnswer = () => {
        stopTimer();
        if (question.questionSetQuestion.questionID)
            tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);

        question.validationFail = !questionValidation(question);

        setQuestion(question);
    };

    const quickDateSelect = (date: string) => {
        question.validationFail = false;
        setDateValue(date);
    }

    return (
        <>
            <div className="question date-picker">
                <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>{question.questionSetQuestion.text}</label>
                <br />
                <div className="date-picker-container">
                    <input
                        type="date"
                        value={getDateFromIsoDateTime(dateValue)}
                        id={"valen_" + question.questionSetQuestion.questionID}
                        className={inputClasses}
                        onChange={(e) => updateAnswer(e)}
                        onFocus={() => startTimer()}
                        onBlur={() => validateAnswer()}
                        min={ddMmYyyyToIsoDate(question.questionSetAnswerType.startRange)}
                        max={ddMmYyyyToIsoDate(question.questionSetAnswerType.endRange)}
                    />
                    {props.enableQuickDateSelect &&
                        <div className="quick-date-buttons">
                            <button className={classNames("btn date-picker", {
                                    unselected: getDateFromIsoDateTime(dateValue) !== today, //append unselected to className
                                    selected: getDateFromIsoDateTime(dateValue) === today
                                })}
                                type="button" onClick={() => quickDateSelect(today)}>Today</button>

                            <button className={classNames("btn date-picker", {
                                unselected: getDateFromIsoDateTime(dateValue) !== tomorrow,
                                selected: getDateFromIsoDateTime(dateValue) === tomorrow
                            })}
                                type="button" onClick={() => quickDateSelect(tomorrow)}>Tomorrow</button>
                        </div>}
                </div>
                {question.questionSetQuestion.helpText !== null && question.questionSetQuestion.helpText !== "" &&
                    <QuestionHelp helpText={question.questionSetQuestion.helpText} questionID={question.questionSetQuestion.questionID} />
                }
                {question.validationFail &&
                    <ValidationMessage question={question} overrideMessage="Please enter a valid date" />}
                {/*<p>Focused: {secondsFocused}</p>*/}
            </div>
        </>

    );
};